import React from "react";
import ChatWindow from "./components/ChatWindow";

function App() {
  return (
    <div className="App">
      <ChatWindow />
    </div>
  );
}

export default App;
